import casinoSiteTypeConst, {
  SiteType
} from "@common_lib/base/constants/casinoSiteTypeConst"

export enum GAME_SCREEN_MODE {
  "HALF" = 0,
  "PAGE" = 1
}
const MODE_MAP: Record<string, GAME_SCREEN_MODE> = {
  "0": GAME_SCREEN_MODE.HALF,
  "1": GAME_SCREEN_MODE.PAGE
}

const useMiniGameStore = defineStore("miniGameStore", () => {
  const websiteInfoStore = useWebsiteInfoStore()
  const { state } = storeToRefs(websiteInfoStore)

  const { reset } = useLoading("MINI_GAME")

  const url = ref("")

  const vendorSite = ref(casinoSiteTypeConst.YUVI.value)
  const isShowErrorBlock = ref(false)

  const handlerLoginAddress = (vendorUrl: string) => {
    url.value = vendorUrl
  }

  const handleMingGameLogout = async () => {
    url.value = ""
    reset()
    vendorSite.value = !state.value.isEnableYuviEntrance
      ? casinoSiteTypeConst.MINIGAME.value
      : casinoSiteTypeConst.YUVI.value
  }

  const handleVendorSite = (site: SiteType) => {
    vendorSite.value = site
  }

  const gameScreenMode = ref<GAME_SCREEN_MODE>(GAME_SCREEN_MODE.HALF)

  const updateGameScreenMode = (target: string) => {
    gameScreenMode.value = MODE_MAP[target] ?? GAME_SCREEN_MODE.HALF
  }

  watch(
    () => state.value.isEnableYuviEntrance,
    yuviGame => {
      if (!yuviGame) {
        handleVendorSite(casinoSiteTypeConst.MINIGAME.value)
      }
    },
    { immediate: true }
  )

  return {
    url,
    vendorSite,
    gameScreenMode,
    isShowErrorBlock,
    handleVendorSite,
    handlerLoginAddress,
    handleMingGameLogout,
    updateGameScreenMode
  }
})

export default useMiniGameStore
